import { TextProps, Text } from "@chakra-ui/react";
import { Helmet } from "react-helmet";
import { ContentWidthContainer } from "../components/ContentWidthContainer";
import { PageHeader } from "../components/PageHeader";

const TermsAndConditionsText: React.FC<TextProps> = (props) => (
  <Text fontSize="16px" lineHeight="24px" mb={4} color="#5b5b5a" fontFamily="poppins, sans-serif" {...props} />
);
const TermsAndConditionsHeader: React.FC<TextProps> = (props) => (
  <TermsAndConditionsText textTransform="uppercase" {...props} />
);

const FIRST_PARAGRAPH = `www.holidayhomes.breakfreeholidays.co.uk is a website managed by BREAKFREE HOLIDAYS LIMITED and is
referred to below as the “Site”.`;

export const TermsAndConditions: React.FC = () => (
  <>
    <Helmet>
      <title>Terms and Conditions - Holiday Homes for Sale</title>
      <meta name="description" content={FIRST_PARAGRAPH} />
    </Helmet>

    <PageHeader>Terms and Conditions</PageHeader>
    <ContentWidthContainer>
      <TermsAndConditionsText>{FIRST_PARAGRAPH}</TermsAndConditionsText>

      <TermsAndConditionsText>
        In these terms and conditions 'we' and 'us' mean BREAKFREE HOLIDAYS LIMITED, a company incorporated under the
        Laws of England and Wales under number 05753643 whose registered office is at 42 Phoenix Court Hawkins Road,
        Colchester, England, CO2 8JY.
      </TermsAndConditionsText>

      <TermsAndConditionsText>
        This Site is maintained for your personal use and viewing. Access and use by you of this Site constitutes
        acceptance by you of these Terms and Conditions of Use.
      </TermsAndConditionsText>

      <TermsAndConditionsText>
        This version of the Terms and Conditions takes effect from 8th July 2024.
      </TermsAndConditionsText>

      <TermsAndConditionsText>
        These Terms and Conditions shall be governed by and construed in accordance with the laws of England and Wales.
        You agree that any dispute in connection with these Terms and Conditions of Use or arising out of your use of
        this Site shall be subject to English law and to the exclusive jurisdiction of the courts of England and Wales.
        We reserve the right to make updates and modifications to these Terms and Conditions of Use from time to time.
      </TermsAndConditionsText>

      <TermsAndConditionsText>
        Please ensure you check these Terms and Conditions of Use each time you access or use this Site. In interpreting
        these Terms and Conditions of Use it is not intended that the headings should be taken into account.
      </TermsAndConditionsText>

      <TermsAndConditionsHeader>1. Acknowledgment of electronic transactions</TermsAndConditionsHeader>
      <TermsAndConditionsText>
        If you send us a communication electronically, we will endeavour to acknowledge it within five working days. If
        we do not, please contact us again. Since transmission by e-mail is a reliable but not an infallible means of
        communication, you should not take proof of transmission as proof of receipt.
      </TermsAndConditionsText>

      <TermsAndConditionsHeader>2. Confidentiality and Security</TermsAndConditionsHeader>
      <TermsAndConditionsText>
        There is no guarantee that the contents of any e-mail you send to us will remain confidential during internet
        transmission. The internet is not a completely secure medium of communication and, accordingly, we do not
        guarantee the security or confidentiality of any TermsAndConditionsText transmitted via the internet. We are not
        responsible for any damages you or others may suffer as a result of the loss of confidentiality of such
        TermsAndConditionsText. We comply with the provisions of the data protection policy in respect of data that you
        send us. Please read our data protection policy which can be found here.
      </TermsAndConditionsText>

      <TermsAndConditionsHeader>3. Virus and Malware Protection and Liability</TermsAndConditionsHeader>
      <TermsAndConditionsText>
        We make reasonable efforts to check and test material on the Site for viruses and other malware at all stages of
        production. However, you should always run and rely on your own anti-virus and anti-malware program on all
        material downloaded from the Internet. We do not accept any responsibility for any loss, disruption or damage to
        your data or your computer system which may occur by downloading or using material derived from this Site. We
        are not responsible for the accuracy or content of advertisements placed on the Site. We accept those
        advertisements in good faith from the business or consumers who place them and which businesses and consumers
        are exclusively responsible for their accuracy and content.
      </TermsAndConditionsText>

      <TermsAndConditionsHeader>4. Cookies and Links Cookies</TermsAndConditionsHeader>
      <TermsAndConditionsText>
        When you visit this Site, we may attach a "cookie" to your browser. A cookie may enable us to identify you from
        your address on the Internet, track pages you have visited on this Site and identify items that may be of
        interest to you. If you would prefer that we did not collect data by this method, you can disable this function
        within your browser settings. Please be aware, however, that without cookies you may not be able to use the full
        functionality of the Site. Any questions on this do let us know at enquiries@breakfreeholidays.co.uk.
      </TermsAndConditionsText>

      <TermsAndConditionsHeader>Linking to us</TermsAndConditionsHeader>
      <TermsAndConditionsText>
        You do not have to ask permission to link directly to pages hosted on this Site, unless the page is within a
        secure part of the Site, in which case the functionality of this Site will prevent you doing so successfully. We
        do not object to you linking directly to the TermsAndConditionsText that is hosted on our Site. However, you may
        not load a page from our Site directly into a frame on another website. The page from our Site should load into
        the user's entire window.
      </TermsAndConditionsText>
      <TermsAndConditionsHeader>Linking by us</TermsAndConditionsHeader>
      <TermsAndConditionsText>
        It is our policy to obtain permission to link to other websites. We are not responsible for the content or
        reliability of any website that we may link to. If we link to another website, that linking should not be taken
        as endorsement by us of any kind. We do not guarantee that these links will work at all times. If you do
        experience a failed link, please report it by email to enquiries@breakfreeholidays.co.uk. If you would like us
        to consider linking to you, please contact us at enquiries@breakfreeholidays.co.uk.
      </TermsAndConditionsText>
    </ContentWidthContainer>
  </>
);
